webpackJsonp([1],{

/***/ "19pQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MachineRow__ = __webpack_require__("9EmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_data__ = __webpack_require__("QevY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Subcribe",
  props: {
    statuses: Object,
    template: Object,
    canSms: Boolean,
    themeConfig: Object
  },
  data: function data() {
    return {
      auto: "auto",
      isLoading: false,
      machine: null,
      machineTemplate: null,
      rowRef: null,
      form: {
        machineTimeBeforeComplete: "P0Y0M0DT0H0M0S",
        isEmail: true
      },
      availableAlerts: [{
        title: "Email",
        isEmail: true
      }, {
        title: "Text SMS",
        isEmail: false
      }],
      alertTriggers: [{
        title: "when machine is finished",
        remainingSeconds: "P0Y0M0DT0H0M0S"
      }, {
        title: "has 1 minute left",
        remainingSeconds: "P0Y0M0DT0H1M0S"
      }, {
        title: "has 3 minutes left",
        remainingSeconds: "P0Y0M0DT0H3M0S"
      }, {
        title: "has 5 minutes left",
        remainingSeconds: "P0Y0M0DT0H5M0S"
      }],
      siteKey: window.siteKey
    };
  },

  components: {
    "machine-row": __WEBPACK_IMPORTED_MODULE_0__MachineRow__["a" /* default */],
    MaskedInput: __WEBPACK_IMPORTED_MODULE_1_vue_masked_input__["a" /* default */]
  },
  mounted: function mounted() {
    // https://mottie.github.io/tablesorter
    $("#statusTable").tablesorter({
      sortList: [[0, 0]],
      sortReset: true
      // widgets: ["saveSort"]
    });
  },
  updated: function updated() {
    // Tablesorter must be updated after tbody has rows
    $("#statusTable").trigger("update");
  },

  computed: {
    validated: function validated() {
      if (this.form.phone || this.form.email) {
        return false;
      }
      return true;
    },
    modalButtonDisabled: function modalButtonDisabled() {
      if (this.validated || this.isLoading) {
        return true;
      }
      return false;
    }
  },
  methods: {
    updateStatus: function updateStatus() {
      $("#statusTable").trigger("update");
    },
    alertTypeChange: function alertTypeChange() {
      if (this.form.isEmail) {
        this.$delete(this.form, "phone");
      } else {
        this.$delete(this.form, "email");
      }
    },
    resetAlertForm: function resetAlertForm() {
      this.$delete(this.form, "phone");
      this.$delete(this.form, "email");
      this.form.isEmail = true;
      this.form.machineTimeBeforeComplete = "P0Y0M0DT0H0M0S";
    },
    submit: function submit() {
      var _this = this;

      this.isLoading = true;

      grecaptcha.ready(function () {
        grecaptcha.execute(_this.siteKey, { action: 'submit' }).then(function (recaptchaToken) {
          _this.form.recaptchaToken = recaptchaToken;

          var alertType = _this.form.isEmail ? 'email' : 'phone';
          console.log('event:created-' + alertType + '-alert');
          _this.$ga.event({
            eventCategory: 'room ' + _this.$route.query.room,
            eventAction: 'created-' + alertType + '-alert'
          });

          Object(__WEBPACK_IMPORTED_MODULE_2__services_data__["h" /* submitMachineSubscription */])(_this.$route.query.room, _this.machine.id, _this.form, _this.template).then(function (response) {
            _this.rowRef.hasSubscribed = true;
            _this.$modal.hide("alertModal");
          }).catch(function (e) {
            console.log("> e", e);
          }).finally(function () {
            _this.isLoading = false;
          });
        });
      });
    },
    showAlertModal: function showAlertModal(machine, template, ref) {
      this.machine = machine;
      this.machineTemplate = template;
      this.rowRef = ref;

      console.log('event:create-alert-opened');
      this.$ga.event({
        eventCategory: 'room ' + this.$route.query.room,
        eventAction: 'create-alert-opened'
      });

      this.resetAlertForm();
      this.$modal.show("alertModal");
    },
    hideAlertModal: function hideAlertModal() {
      this.$modal.hide("alertModal");
    },
    beforeAlertClose: function beforeAlertClose(event) {
      console.log('event:create-alert-closed');
      this.$ga.event({
        eventCategory: 'room ' + this.$route.query.room,
        eventAction: 'create-alert-closed'
      });
    }
  }
});

/***/ }),

/***/ "1AHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__machine_StatusPill__ = __webpack_require__("dCsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__machine_TimeRemaining__ = __webpack_require__("cclF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Subcribe",
  props: {
    machine: Object,
    template: Object,
    canSms: Boolean,
    themeConfig: Object
  },
  data: function data() {
    return {
      hasSubscribed: false
    };
  },

  components: {
    "status-pill": __WEBPACK_IMPORTED_MODULE_0__machine_StatusPill__["a" /* default */],
    "time-remaining": __WEBPACK_IMPORTED_MODULE_1__machine_TimeRemaining__["a" /* default */]
  },
  computed: {
    isActive: function isActive() {
      var mStatus = this.machine.statusId;

      if (mStatus == "in_use" || mStatus == "lucky_cycle" || mStatus == "almost_done" || mStatus == "ready_to_start") {
        return true;
      }
    },
    machineType: function machineType() {
      return this.machine.isWasher ? "Washer" : "Dryer";
    }
  },
  methods: {
    show: function show() {
      this.$parent.showAlertModal(this.machine, this.template, this);
    }
  }
});

/***/ }),

/***/ "1ZoI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "44Zi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


// This is the list of statuses and the labels to use (not localized)
var STATUS_LEVELS = [{
  name: "available",
  label: "available",
  status: ["AVAILABLE"],
  colors: ["#45b854", "#128521"],
  in_legend: true
}, {
  name: "in use",
  label: "in use",
  status: ["IN_USE", "ALMOST_DONE", "DOOR_OPEN", "LUCKY_CYCLE", "READY_TO_START", "RESERVED"],
  colors: ["#f3a537", "#c07204"],
  in_legend: true
}, {
  name: "complete",
  label: "complete",
  status: ["COMPLETE"],
  colors: ["#2a8bda", "#0058a7"],
  in_legend: true
}, {
  name: "error",
  label: "error",
  status: ["ERROR"],
  colors: ["#D0011B", "#a90015"],
  in_legend: true
}, {
  name: "offline",
  label: "offline",
  status: ["DEFAULT", "UNKNOWN", "NETWORK_ERROR", "UNAVAILABLE"],
  colors: ["#c6cccf", "#93999c"],
  in_legend: true
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "StatusPill",
  props: {
    status: String,
    themeConfig: Object
  },
  data: function data() {
    return {
      statusClassObject: {}
    };
  },

  computed: {
    statusFormatted: function statusFormatted() {
      var status = this.status === undefined ? "OFFLINE" : this.status.toUpperCase();
      var statusObj = void 0;
      var statusLevels = void 0;

      // Fallback to defaults if themeConfig is missing what we need
      if (this.themeConfig && this.themeConfig.status) {
        statusLevels = this.themeConfig.status;
      } else {
        statusLevels = STATUS_LEVELS;
      }

      statusObj = statusLevels.find(function (item) {
        return item.status.includes(status);
      });

      var statusLabel = statusObj && statusObj.label ? statusObj.label : "offline"; // Use .label as the text
      var statusName = statusObj && statusObj.name ? statusObj.name : "offline"; // Use .name as the class name

      this.statusClassObject = {};
      this.statusClassObject["" + statusName.replace(' ', '_')] = true;

      return statusLabel;
    },
    statusColor: function statusColor() {
      var currentStatus = this.status;
      var themeConfig = this.themeConfig;

      // Return status colors defined in theme.json -or- defaultColors -or- fallbackColors
      if (currentStatus !== undefined) {
        currentStatus = currentStatus.toUpperCase();
      } else {
        currentStatus = "UNKNOWN";
      }

      var fallbackColors = ["#c6cccf", "#999d9e"];
      var statusList = void 0;

      if (themeConfig.status) {
        statusList = themeConfig.status;
      } else {
        statusList = STATUS_LEVELS;
      }

      function findStatusColor(currentStatus, statusList) {
        return statusList.find(function (item) {
          return item.status.includes(currentStatus);
        });
      }

      // Return the correct status to use
      if (findStatusColor(currentStatus, statusList)) {
        return findStatusColor(currentStatus, statusList).colors[0];
      }
      if (findStatusColor("DEFAULT", statusList)) {
        return findStatusColor("DEFAULT", statusList).colors[0];
      }
      return fallbackColors[0];
    }
  }
});

/***/ }),

/***/ "4Uvx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4gk4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6nAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_data__ = __webpack_require__("QevY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_masked_input__ = __webpack_require__("4q2C");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "RoomSubscribe",
  props: {
    template: Object,
    canSms: Boolean
  },
  data: function data() {
    return {
      isLoading: false,
      hasSubscribed: false,
      form: {
        isEmail: true,
        washerCountAbove: 0,
        dryerCountAbove: 0
      },
      availableAlerts: [{
        title: "Email me",
        isEmail: true
      }, {
        title: "SMS me",
        isEmail: false
      }],
      siteKey: window.siteKey
    };
  },

  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_2_vue_masked_input__["a" /* default */]
  },
  computed: {
    thresholdRange: function thresholdRange() {
      var arr = [];
      for (var i = 0; i < 20; i++) {
        arr.push(i);
      }
      return arr;
    },
    validated: function validated() {
      if (this.form.phone || this.form.email) {
        if (this.form.washerCountAbove > 0 || this.form.dryerCountAbove > 0) {
          this.hasSubscribed = false;
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    alertTypeChange: function alertTypeChange() {
      if (this.form.isEmail) {
        this.$delete(this.form, "phone");
      } else {
        this.$delete(this.form, "email");
      }
    },
    submit: function submit() {
      var _this = this;

      this.isLoading = true;

      grecaptcha.ready(function () {
        grecaptcha.execute(_this.siteKey, { action: 'submit' }).then(function (recaptchaToken) {
          _this.form.recaptchaToken = recaptchaToken;

          Object(__WEBPACK_IMPORTED_MODULE_1__services_data__["i" /* submitRoomSubscription */])(_this.$route.query.room, _this.form, _this.template).then(function (response) {
            _this.hasSubscribed = true;
            _this.form = {
              isEmail: true,
              washerCountAbove: 0,
              dryerCountAbove: 0
            };
          }).catch(function (e) {
            console.log("> e", e);
          }).finally(function () {
            _this.isLoading = false;
          });
        });
      });
    }
  }
});

/***/ }),

/***/ "74vk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-background"}},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wa-view"}},[_c('div',{staticClass:"container",attrs:{"id":"title"}},[_c('div',{staticClass:"row center"},[_c('div',{staticClass:"column"},[_c('header',[(_vm.roomLogo)?_c('img',{staticClass:"hero-logo",attrs:{"src":_vm.roomLogo}}):_vm._e(),_vm._v(" "),(_vm.showRoomName)?_c('h3',[_vm._v(_vm._s(_vm.roomName))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"canvas"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('room',{ref:"room",attrs:{"roomLabelMeta":_vm.roomLabelMeta,"roomId":_vm.roomId,"gridSizePx":_vm.gridSizePx,"roomName":_vm.roomName,"roomLogo":_vm.roomLogo,"themeConfig":_vm.themeConfig}}),_vm._v(" "),_c('div',{staticClass:"center",attrs:{"id":"bottom-controls"}},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.togglePageView}},[_vm._v("Toggle compact view")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"container__full-width",attrs:{"id":"status"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('subscribe',{ref:"subscribe",attrs:{"statuses":_vm.statuses,"template":_vm.template,"canSms":_vm.roomCanSms,"themeConfig":_vm.themeConfig}}),_vm._v(" "),_c('room-subscribe',{attrs:{"template":_vm.template,"canSms":_vm.roomCanSms}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"container__full-width bg-dark",attrs:{"id":"message"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('service')],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ad-view"}},[_c('img',{staticClass:"ad-slide",attrs:{"data-type":"wa"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7lM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"hide-td"},[_vm._v(_vm._s(_vm.machine.networkNode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.machineType)+" "+_vm._s(_vm.machine.machineDisplayName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.machine.machineSize))]),_vm._v(" "),_c('td',[_c('status-pill',{attrs:{"status":_vm.machine.statusId,"themeConfig":_vm.themeConfig}})],1),_vm._v(" "),(_vm.isActive)?_c('td',[_c('time-remaining',{attrs:{"remainingSeconds":_vm.machine.remainingSeconds}}),_vm._v(" "),(_vm.isActive)?_c('div',[(!_vm.hasSubscribed)?_c('div',[_c('a',{on:{"click":_vm.show}},[_vm._v("\n          Create Alert\n        ")])]):_c('div',[_c('span',[_vm._v("Subscribed")])])]):_vm._e()],1):_c('td')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9EmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MachineRow_vue__ = __webpack_require__("1AHx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec0aa5f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachineRow_vue__ = __webpack_require__("7lM9");
function injectStyle (ssrContext) {
  __webpack_require__("bRv8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec0aa5f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MachineRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec0aa5f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachineRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_data__ = __webpack_require__("QevY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Room__ = __webpack_require__("t3u0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Directory__ = __webpack_require__("IPjP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscribe__ = __webpack_require__("YTo8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Service__ = __webpack_require__("MPfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__room_RoomSubscribe__ = __webpack_require__("hx1J");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var almostDoneThreshold = 240; // Seconds until cycle complete

function getQueryStringParameter(paramName) {
  var regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(window.location.href);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  components: {
    Room: __WEBPACK_IMPORTED_MODULE_1__Room__["a" /* default */],
    Directory: __WEBPACK_IMPORTED_MODULE_2__Directory__["a" /* default */],
    Subscribe: __WEBPACK_IMPORTED_MODULE_3__Subscribe__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_4__Service__["a" /* default */],
    RoomSubscribe: __WEBPACK_IMPORTED_MODULE_5__room_RoomSubscribe__["a" /* default */]
  },
  data: function data() {
    return {
      roomName: "",
      roomLabelMeta: null,
      roomId: null,
      gridSizePx: 800,
      roomLogo: "",
      statuses: null,
      roomCanSms: true,
      showRoomName: false,
      adMode: false,
      themeConfig: null,
      template: {
        id: "",
        roomId: "",
        machineId: "",
        machineTimeId: ""
      },
      backgroundStyle: "",
      timerTopOffset: 0,
      timerWidthOffset: 0
    };
  },
  beforeMount: function beforeMount() {
    console.log('v2.5.1');
    // HACK SPECIAL ROOM GETS BIGGER GRID
    if (this.$route.query.room == 133) {
      this.gridSizePx = 840;
    } else {
      this.gridSizePx = 800;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var vueThis = this;

    if (window.location.href.indexOf("mode=tv") != -1) {
      $(".wrapper").addClass("tv-mode");
      Object(__WEBPACK_IMPORTED_MODULE_0__services_data__["a" /* getAds */])(this.$route.query.room).then(function (results) {
        if (results.data) {
          vueThis.loadAdSlides(results.data);
          vueThis.startAdSlideshow();
        }
      });
    }

    if (this.$route.query.compact) {
      $("#status, #message").hide();
    }
    if (this.$route.query.room) {
      var roomId = this.$route.query.room;
      var orgId = this.$route.params.orgId;

      Object(__WEBPACK_IMPORTED_MODULE_0__services_data__["d" /* getTemplates */])().then(function (results) {
        var data = results.data[0];
        if (!data) console.log(data); // todo: handle this?

        _this.template.id = data.id;
        data.subscriptionConditionTemplates.forEach(function (template) {
          var type = template.subscriptionConditionType;
          switch (type.lookupKey) {
            case "ROOM_ID":
              _this.template.roomId = type.id;
              break;
            case "MACHINE_ID":
              _this.template.machineId = type.id;
              break;
            case "MACHINE_TIME_BEFORE_COMPLETE":
              _this.template.machineTimeId = type.id;
              break;
            case "AVAILABLE_DRYER_COUNT_ABOVE":
              _this.template.dryerCountAbove = type.id;
              break;
            case "AVAILABLE_WASHER_COUNT_ABOVE":
              _this.template.washerCountAbove = type.id;
              break;
          }
        });
      });
      var machines = {};

      Object(__WEBPACK_IMPORTED_MODULE_0__services_data__["c" /* getMachines */])(orgId, roomId).then(function (results) {
        results.data.forEach(function (machine) {
          machines[machine.id] = {
            id: machine.id,
            controlId: machine.controlId,
            serialNumber: machine.serialNumber,
            isWasher: machine.machineType.isWasher,
            isDryer: machine.machineType.isDryer,
            machineNumber: machine.machineNumber,
            machineName: machine.machineName,
            machineDisplayName: machine.machineName && machine.machineName.length <= 8 && machine.machineName.length > 0 ? machine.machineName : machine.machineNumber.replace(/^0+/, ""),
            machineSize: machine.machineType.typeName,
            machineTypeName: machine.machineType.typeName,
            networkNode: machine.networkNode,
            washAlertScaleX: machine.washAlertScaleX,
            washAlertScaleY: machine.washAlertScaleY,
            washAlertXAxis: machine.washAlertXAxis,
            washAlertYAxis: machine.washAlertYAxis,
            washAlertAngle: machine.washAlertAngle,
            washAlertIsVisible: machine.washAlertIsVisible,
            washAlertZIndex: machine.washAlertZIndex,
            machineType: machine.machineType,
            machineAuditType: machine.machineAuditType.id,
            modelNumber: machine.modelNumber,
            statusId: "init"
          };

          // convert machine size for Australia
          if (orgId === '450828') {
            if (!machines[machine.id].isDryer && machines[machine.id].machineSize.indexOf('13.6') != -1) {
              machines[machine.id].machineSize = 'Washer Extractor 14 kg.';
            }
          }
        });

        function showElement(property, defaultValue) {
          if (property === undefined) {
            return defaultValue;
          } else {
            return property;
          }
        }

        function loadStyle(filename) {
          var cssFile = document.createElement('link');
          cssFile.rel = "stylesheet";
          cssFile.href = filename;
          document.head.appendChild(cssFile);
        }

        __WEBPACK_IMPORTED_MODULE_0__services_data__["e" /* roomsRef */].child(roomId).once("value").then(function (snapshot) {
          var room = snapshot.val();
          _this.roomName = room.roomName;
          _this.roomId = room.id;
          _this.roomLogo = room.logoUrl;
          _this.roomLabelMeta = room.roomLabelMeta;
          _this.roomCanSms = room.canSms;
          _this.showRoomName = showElement(room.hasWashAlertRoomName, true);
          _this.s3ImageUrl = room.s3ImagePath;

          // Get the theme configuration
          var themeConfig = void 0;
          var theme = room.washAlertTheme || 'theme1';

          // Theme override for testing (disabled while forcing automatic theme)
          var themeOverride = getQueryStringParameter('theme');
          if (themeOverride) {
            theme = themeOverride;
          }

          $.ajax({ async: false, dataType: 'JSON', url: "/static/themes/" + theme + "/theme.json" }).done(function (json) {
            themeConfig = json;
          });

          _this.themeName = theme;
          _this.themeConfig = themeConfig;
          if (themeConfig["use-stylesheet"]) {
            loadStyle("/static/themes/" + theme + "/style.css");
          }

          if (themeConfig["timer-top-offset"]) {
            _this.timerTopOffset = themeConfig["timer-top-offset"];
          }

          if (themeConfig["timer-width-offset"]) {
            _this.timerWidthOffset = themeConfig["timer-width-offset"];
          }

          // Add style to the top background of Wash Alert
          if (themeConfig && themeConfig["top-background-style"]) {
            _this.backgroundStyle = themeConfig["top-background-style"];
          }

          console.log("Theme:", theme);

          // This does the initial roomUpdate/creation
          // Use $nextTick to ensure the room component is fully mounted before calling roomUpdate
          _this.$nextTick(function () {
            console.log('Checking room ref:', _this.$refs.room);
            console.log('All refs:', _this.$refs);
            if (_this.$refs.room && _this.$refs.room.roomUpdate) {
              console.log('Calling roomUpdate');
              _this.$refs.room.roomUpdate(room, machines, {
                showClock: showElement(room.hasWashAlertClock, true),
                showLegend: showElement(room.hasWashAlertLegend, true),
                canvasResize: showElement(room.washAlertCanvasResize, false),
                s3ImagePath: showElement(room.s3ImagePath, ""),
                themeConfig: themeConfig
              });
            } else {
              console.error('Room component ref not available');
            }
          });
          // no SMS for Australia
          if (orgId === '450828') {
            _this.roomCanSms = false;
          }

          // This is used to monitor the status of the machines
          __WEBPACK_IMPORTED_MODULE_0__services_data__["g" /* statusesRef */].orderByChild("roomId").equalTo(_this.roomId.toString()).on("value", function (snap) {
            // This anonymous function is called when data is initially loaded and every time the data changes.
            snap.forEach(function (childSnap) {
              var key = childSnap.key;
              var value = childSnap.val();

              // Do not update if the machine is not in the array of machines
              if (!machines[key]) {
                return;
              }

              // Do not update if the receivedAt hasn't changed since the last update
              if (value.receivedAt == machines[key].receivedAt) {
                return;
              }

              machines[key].hasUpdate = true; // Flag update for the room component
              machines[key].receivedAt = value.receivedAt;
              machines[key].isDoorOpen = value.isDoorOpen;
              machines[key].networkNode = machines[key].networkNode;
              machines[key].remainingSeconds = value.remainingSeconds;

              // Transform IN_USE to ALMOST_DONE when remaining time is less than 4 minutes (240 seconds)
              var statusId = value.statusId ? value.statusId.toLowerCase() : '';
              if (statusId === 'in_use' && value.remainingSeconds && value.remainingSeconds < almostDoneThreshold) {
                statusId = 'almost_done';
              }
              machines[key].statusId = statusId;

              machines[key].statusMonitorUpdatedAt = value.statusMonitorUpdatedAt;
            });

            _this.$set(_this, "statuses", machines);
            // Use $nextTick to ensure components are fully mounted before calling methods
            _this.$nextTick(function () {
              if (_this.$refs.room && _this.$refs.room.machineUpdate) {
                _this.$refs.room.machineUpdate(machines); // Reaches down into the room component and updates the machines
              }
              if (_this.$refs.subscribe && _this.$refs.subscribe.updateStatus) {
                _this.$refs.subscribe.updateStatus();
              }
            });
          });
        });

        // setup analytics now that we have org and room info
        var enableGa = function enableGa() {
          vueThis.$ga.enable();
          var org = results.data[0].organization;
          var room = results.data[0].room;

          // Override page url - changing this after the initial push to prod will cause a schism and discontinuity of the data in google analytics
          var pageUrl = 'Org:' + org.id + ' ' + org.organizationName;
          // These 3 set's apply to all every single event/pageview from here on out
          vueThis.$ga.set('dimension1', 'Org:' + org.id + ' ' + org.organizationName);
          vueThis.$ga.set('dimension2', 'Room:' + room.id + ' ' + room.roomName);
          vueThis.$ga.set('page', pageUrl); // set url for all events
          vueThis.$ga.page(pageUrl); // fire page view
          console.log('event:pageview');
        };
        var enabledIfHasConsented = function enabledIfHasConsented() {
          if (this.hasConsented()) {
            enableGa();
          } else {
            vueThis.$ga.disable();
          }
        };

        // hide cookie banner for tv mode
        if (window.location.href.indexOf("mode=tv") == -1) {
          window.cookieconsent.initialise({
            // customize here: https://cookieconsent.insites.com/download/
            palette: {
              popup: {
                background: "#eaf7f7",
                text: "#5c7291"
              },
              button: {
                background: "#56cbdb",
                text: "#ffffff"
              }
            },
            theme: "classic",
            position: "top",
            type: "opt-in",
            location: true,
            onNoCookieLaw: function onNoCookieLaw() {
              enableGa();
            },
            onStatusChange: enabledIfHasConsented,
            onRevokeChoice: enabledIfHasConsented
          });
        }
      });
    } else {
      this.$set(this, "roomName", "Need a valid room.");
    }
  },

  methods: {
    togglePageView: function togglePageView(e) {
      e.preventDefault();

      if ($("#status").is(":visible")) {
        $("#status, #message").hide();
      } else {
        $("#status, #message").show();
      }
    },
    loadAdSlides: function loadAdSlides(slides) {
      var slideshow = $("#ad-view");

      if (slides && slides.length > 0) {
        slideshow.empty();
      }

      slides.forEach(function (slide) {
        var slideImg = $("<img />");

        slideImg.addClass("ad-slide");
        slideImg.attr("data-type", slide.advertisementTypeLookupKey == "WASH_ALERT" ? "wa" : "ad");
        slideImg.attr("src", slide.imageUrl);
        slideImg.attr("data-backgroundcolor", slide.background);
        slideImg.attr("data-duration", slide.duration);

        slideshow.append(slideImg);
      });
    },
    toggleAdMode: function toggleAdMode(e) {
      e.preventDefault();

      if (this.adMode) {
        this.endAdSlideshow();
      } else {
        this.startAdSlideshow();
      }
    },
    startAdSlideshow: function startAdSlideshow() {
      var self = this;
      var firstSlide = $(".ad-slide:first");
      var duration = firstSlide.data("duration") * 1000 || 5000;

      if (firstSlide.data("type") === "wa") {
        $("#ad-view").hide();
        $("#wa-view").hide().removeClass("hide").show();
      } else {
        $("#wa-view").hide().addClass("hide").show();
        $("#ad-view").show();
      }

      firstSlide.show().addClass("active");

      this.adMode = setTimeout(function () {
        self.showNextSlide();
      }, duration);
    },
    endAdSlideshow: function endAdSlideshow() {
      clearTimeout(this.adMode);

      $("#ad-view").hide();
      $("#wa-view").hide().removeClass("hide").show();
      $(".ad-slide").hide().removeClass("active");

      this.adMode = false;
    },
    showNextSlide: function showNextSlide() {
      clearTimeout(this.adMode);

      var self = this;
      var currentSlide = $(".ad-slide.active");
      var nextSlide = currentSlide.next(".ad-slide");

      if (nextSlide.length === 0) {
        nextSlide = $(".ad-slide:first");
      }

      var duration = nextSlide.data("duration") * 1000 || 5000;

      if (currentSlide.data("type") === "wa" && nextSlide.data("type") !== "wa") {
        $("#wa-view").hide("slide", { direction: "left" }, function () {
          $("#ad-view").show("slide", { direction: "right" });
        }).addClass("hide").show();
      } else if (currentSlide.data("type") !== "wa" && nextSlide.data("type") === "wa") {
        $("#ad-view").hide("slide", { direction: "left" }, function () {
          $("#wa-view").hide().removeClass("hide").show("slide", { direction: "right" });
        });
      }

      $("#ad-view").css("background", nextSlide.data("backgroundcolor") || "");

      currentSlide.removeClass("active").hide("slide", { direction: "left" }, function () {
        nextSlide.show("slide", { direction: "right" }).addClass("active");
      });

      this.adMode = setTimeout(function () {
        self.showNextSlide();
      }, duration);
    }
  }
});

/***/ }),

/***/ "GfpX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HWUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"container--section container--section-service"},[_c('h2',[_vm._v("Send a service message")]),_vm._v(" "),_c('h5',[_vm._v("Report any issues straight to us")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('fieldset',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Your Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"type":"text","id":"email","placeholder":"you@email.com"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Your Phone (optional)")]),_vm._v(" "),(this.$route.query.room == 49 || this.$route.query.room == 114 || this.$route.query.room == 131 || this.$route.query.room == 133 || this.$route.query.room == 178)?_c('masked-input',{attrs:{"mask":"\\+6\\1 (01) 1111 1111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}):(this.$route.params.orgId == 450828)?_c('masked-input',{attrs:{"mask":"\\+\\6\\1 1111 111111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}):(_vm.isUkOrg(this.$route.params.orgId))?_c('masked-input',{attrs:{"mask":"\\+\\44 1111 111111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}):_c('masked-input',{attrs:{"mask":"\\+\\1 (111) 111-1111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1)]),_vm._v(" "),_c('label',{attrs:{"for":"comment"}},[_vm._v("Comment(s)")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.comment),expression:"form.comment"}],attrs:{"id":"comment","placeholder":"Let us know about any issue you found with a machine or the facility"},domProps:{"value":(_vm.form.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "comment", $event.target.value)}}}),_vm._v(" "),_c('div',{attrs:{"id":"recaptcha-container"}}),_vm._v(" "),(!_vm.isLoading)?_c('input',{staticClass:"button-primary g-recaptcha",attrs:{"type":"submit","value":"Send"}}):_c('input',{staticClass:"button-primary",attrs:{"type":"submit","value":"Sending","disabled":""}}),_vm._v(" "),(_vm.hasSent)?_c('span',{staticClass:"success"},[_vm._v("\n            Successfully sent. Thank you for notifying us.\n          ")]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IPjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Directory_vue__ = __webpack_require__("tvWA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50748fa0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Directory_vue__ = __webpack_require__("nSQr");
function injectStyle (ssrContext) {
  __webpack_require__("mfYs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50748fa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Directory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50748fa0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Directory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ldef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_data__ = __webpack_require__("QevY");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Service",
  data: function data() {
    return {
      form: {},
      isLoading: false,
      hasSent: false,
      ukOrgs: ['891908', '760256', '486822', '862928', '1090139', '652210', '912247', '767776', '499898'],
      siteKey: window.siteKey
    };
  },

  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_2_vue_masked_input__["a" /* default */]
  },
  methods: {
    isValidEmail: function isValidEmail(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    isUkOrg: function isUkOrg(orgId) {
      return this.ukOrgs.indexOf(orgId) > -1;
    },
    submitForm: function submitForm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.isValidEmail(_this.form.email)) {
                  _context.next = 3;
                  break;
                }

                alert("Please include your email with your message.");
                return _context.abrupt("return");

              case 3:

                _this.isLoading = true;

                grecaptcha.ready(function () {
                  grecaptcha.execute(_this.siteKey, { action: 'submit' }).then(function (recaptchaToken) {
                    _this.form.recaptchaToken = recaptchaToken;
                    var roomId = _this.$route.query.room;

                    _this.$ga.event({
                      eventCategory: 'room ' + _this.$route.query.room,
                      eventAction: 'service-email-sending'
                    });

                    Object(__WEBPACK_IMPORTED_MODULE_3__services_data__["f" /* sendServiceEmail */])(roomId, _this.form).then(function () {
                      // TODO: Handle any errors from the endpoint
                      _this.form = {};
                      _this.hasSent = true;
                      console.log("sent");
                      console.log('event:service-email-sent');
                      _this.$ga.event({
                        eventCategory: 'room ' + _this.$route.query.room,
                        eventAction: 'service-email-sent'
                      });
                    }).catch(function (error) {
                      console.log('event:service-email-failed');
                      _this.$ga.event({
                        eventCategory: 'room ' + _this.$route.query.room,
                        eventAction: 'service-email-failed'
                      });
                      console.log(error);
                      alert("Unable to send email. Please check your email address and try again.");
                    }).finally(function () {
                      _this.isLoading = false;
                    });
                  });
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba395fe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("zd0p");
function injectStyle (ssrContext) {
  __webpack_require__("4Uvx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba395fe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MPfG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__ = __webpack_require__("Ldef");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e03d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__ = __webpack_require__("HWUM");
function injectStyle (ssrContext) {
  __webpack_require__("iDzA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1e03d60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e03d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
  id: "UA-706766-6", // ALS
  disabled: true, // user has to say it's ok first, or we discover it's a country without a cookie law
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_js_modal___default.a);

__webpack_require__("kZDd"); // for IE11 when use vue-js-modal

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  data: {
    config: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config
  },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "QevY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return roomsRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return statusesRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMachines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDirectory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return submitMachineSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return submitRoomSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendServiceEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_config_json__ = __webpack_require__("ZMJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__project_config_json__);




var firebaseApp = __WEBPACK_IMPORTED_MODULE_1_firebase__["initializeApp"]({
  apiKey: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.firebaseKey,
  authDomain: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.firebaseDomain,
  databaseURL: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.firebaseDatabaseUrl,
  projectId: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.firebaseProjectId,
  storageBucket: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.firebaseStorageBucket,
  messagingSenderId: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.firebaseMessagingSenderId
});

var fb = firebaseApp.database();

var roomsRef = fb.ref("/rooms");
var statusesRef = fb.ref("/machineCurrentStatuses");

var getMachines = function getMachines(orgId, roomId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios__["get"](__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/washAlert/machines/" + roomId, {
    headers: {
      "alliancels-organization-id": orgId
    }
  });
};

var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios__["create"]({
  baseURL: __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/",
  headers: {
    "x-api-key": __WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiKey
  }
});

var getDirectory = function getDirectory(roomId) {
  return HTTP.get(__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/washAlert/rooms/" + roomId + "/organization?raw=true");
};

var getAds = function getAds(roomId) {
  return HTTP.get(__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/rooms/" + roomId + "/ads?raw=true");
};

var getTemplates = function getTemplates() {
  return HTTP.get(__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/subscriptionTemplates?eventTypeLookupKey=WASH_ALERT&raw=true");
};

var submitMachineSubscription = function submitMachineSubscription(roomId, machineId, form, template) {
  return HTTP.post(__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/subscriptionTemplates/" + template.id + "/subscriptions", {
    email: form.email,
    phone: form.phone,
    recaptchaToken: form.recaptchaToken,
    subscriptionConditions: [
    // ROOM_ID
    {
      subscriptionConditionTypeId: template.roomId,
      intValue: roomId
    },
    // MACHINE_ID
    {
      subscriptionConditionTypeId: template.machineId,
      intValue: machineId
    },
    // MACHINE_TIME_BEFORE_COMPLETE
    {
      subscriptionConditionTypeId: template.machineTimeId,
      dateValue: form.machineTimeBeforeComplete
    }]
  });
};

var submitRoomSubscription = function submitRoomSubscription(roomId, form, template) {
  return HTTP.post(__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/subscriptionTemplates/" + template.id + "/subscriptions", {
    email: form.email,
    phone: form.phone,
    recaptchaToken: form.recaptchaToken,
    subscriptionConditions: [
    // ROOM_ID
    {
      subscriptionConditionTypeId: template.roomId,
      intValue: roomId
    },
    // AVAILABLE_WASHER_COUNT_ABOVE
    {
      subscriptionConditionTypeId: template.washerCountAbove,
      intValue: form.washerCountAbove
    },
    // AVAILABLE_DRYER_COUNT_ABOVE
    {
      subscriptionConditionTypeId: template.dryerCountAbove,
      intValue: form.dryerCountAbove
    }]
  });
};

var sendServiceEmail = function sendServiceEmail(roomId, form) {
  return HTTP.post(__WEBPACK_IMPORTED_MODULE_2__project_config_json___default.a.allianceApiUrl + "/washAlert/service/" + roomId, {
    email: form.email,
    phone: form.phone,
    comment: form.comment,
    recaptchaToken: form.recaptchaToken
  });
};



/***/ }),

/***/ "VDDG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YTo8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscribe_vue__ = __webpack_require__("19pQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc8374e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscribe_vue__ = __webpack_require__("tQ9O");
function injectStyle (ssrContext) {
  __webpack_require__("1ZoI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dc8374e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscribe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc8374e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscribe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Directory__ = __webpack_require__("IPjP");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: "/directory/:roomId",
    name: "Directory",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Directory__["a" /* default */]
  }, {
    path: "/:orgId",
    name: "Room",
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }],
  mode: "history"
}));

/***/ }),

/***/ "ZMJT":
/***/ (function(module, exports) {

module.exports = {"insightsApiUrl":"https://platform.sqinsights.com","allianceApiUrl":"https://api.sqinsights.com","allianceApiKey":"4da79517795f579f1717d55b25fb1e9d","algoliaAppId":"5225LYV5YI","algoliaApiKey":"d7eb1a944e4b3b0a4402bc1f58419ba0","googleMapApiKey":"AIzaSyDXkXZfhGnMt4vND9T3BwCbxz8xRzWAxGY","firebaseKey":"AIzaSyDXkXZfhGnMt4vND9T3BwCbxz8xRzWAxGY","firebaseDomain":"alliance-insights-prd.firebaseapp.com","firebaseDatabaseUrl":"https://alliance-insights-prd.firebaseio.com","firebaseProjectId":"alliance-insights-prd","firebaseStorageBucket":"alliance-insights-prd.appspot.com","firebaseMessagingSenderId":611730640404,"allianceBrand":"SPEED_QUEEN"}

/***/ }),

/***/ "afiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"container--section"},[(_vm.canSms)?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.isEmail),expression:"form.isEmail"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "isEmail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.alertTypeChange]}},_vm._l((_vm.availableAlerts),function(alertType,idx){return _c('option',{key:idx,domProps:{"value":alertType.isEmail}},[_vm._v(_vm._s(alertType.title))])}),0)]:[_vm._v("\n      Email\n    ")],_vm._v("\n\n    at\n\n    "),(_vm.form.isEmail)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"type":"email","placeholder":"me@email.com"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}):(this.$route.query.room == 49 || this.$route.query.room == 114 || this.$route.query.room == 131 || this.$route.query.room == 133 || this.$route.query.room == 178)?_c('masked-input',{attrs:{"mask":"\\+6\\1 (01) 1111 1111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}):_c('masked-input',{attrs:{"mask":"\\+\\1 (111) 111-1111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}),_vm._v(" "),_c('div',{staticClass:"break"},[_vm._v("\n      when\n\n      "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.washerCountAbove),expression:"form.washerCountAbove"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "washerCountAbove", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.thresholdRange),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v("\n            "+_vm._s(i)+"\n            "),(i == 1)?_c('span',[_vm._v("Washer")]):_c('span',[_vm._v("Washers")])])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.dryerCountAbove),expression:"form.dryerCountAbove"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "dryerCountAbove", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.thresholdRange),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v("\n            "+_vm._s(i)+"\n            "),(i == 1)?_c('span',[_vm._v("Dryer")]):_c('span',[_vm._v("Dryers")])])}),0),_vm._v("\n\n      are available\n\n      "),_c('div',{staticClass:"row"},[(!_vm.validated)?_c('div',{staticClass:"column"},[(!_vm.isLoading)?_c('button',{on:{"click":_vm.submit}},[_vm._v("Send")]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('button',{attrs:{"disabled":_vm.isLoading}},[_vm._v("Sending...")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasSubscribed)?_c('span',{staticClass:"success"},[_vm._v("\n          Thank you. We will reach out to you with your updates.\n        ")]):_vm._e()])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bRv8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cclF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeRemaining_vue__ = __webpack_require__("eyRK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_120b949d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeRemaining_vue__ = __webpack_require__("q4V6");
function injectStyle (ssrContext) {
  __webpack_require__("VDDG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-120b949d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeRemaining_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_120b949d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeRemaining_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dCsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusPill_vue__ = __webpack_require__("44Zi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1965e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusPill_vue__ = __webpack_require__("yoog");
function injectStyle (ssrContext) {
  __webpack_require__("4gk4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusPill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1965e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusPill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eEGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eyRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TimeRemaining",
  props: {
    remainingSeconds: Number
  },
  data: function data() {
    return {};
  },

  computed: {
    timeFormatted: function timeFormatted() {
      var tempTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(this.remainingSeconds, "seconds");
      var minutes = parseInt(tempTime.minutes());
      var hours = parseInt(tempTime.hours());

      var s = hours + " hr. " + minutes + " min. left";

      if (hours <= 0) {
        s = minutes + " min. left";
      }

      if (minutes <= 2 && hours == 0) {
        s = "Finishing...";
      }

      return s;
    }
  }
});

/***/ }),

/***/ "hx1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoomSubscribe_vue__ = __webpack_require__("6nAh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a81d72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoomSubscribe_vue__ = __webpack_require__("afiX");
function injectStyle (ssrContext) {
  __webpack_require__("GfpX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08a81d72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoomSubscribe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a81d72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoomSubscribe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iDzA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ec385a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("74vk");
function injectStyle (ssrContext) {
  __webpack_require__("yqGW")
  __webpack_require__("o0Pv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ec385a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ec385a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mfYs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container__full-width rooms-listing"},[_c('h1',{staticClass:"centered"},[_vm._v(_vm._s(_vm.organizationName))]),_vm._v(" "),_c('ul',_vm._l((_vm.rooms),function(room){return _c('li',[_c('a',{attrs:{"href":'/' + _vm.orgId + '?room=' + room.id}},[_vm._v("\n        "+_vm._s(room.roomName)+"\n      ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o0Pv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q4V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}),_vm._v("\n  "+_vm._s(_vm.timeFormatted)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t3u0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_vue__ = __webpack_require__("xLEQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d721503a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_vue__ = __webpack_require__("xcT/");
function injectStyle (ssrContext) {
  __webpack_require__("eEGv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d721503a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d721503a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQ9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_vm._m(0),_vm._v(" "),_c('table',{attrs:{"id":"statusTable"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.statuses),function(status){return _c('machine-row',{key:status.id,attrs:{"canSms":_vm.canSms,"machine":status,"template":_vm.template,"themeConfig":_vm.themeConfig}})}),1)]),_vm._v(" "),_c('modal',{attrs:{"name":"alertModal","height":_vm.auto,"width":360},on:{"before-close":_vm.beforeAlertClose}},[_c('header',[_c('span',{staticClass:"hero fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fa fa-bell fa-stack-1x fa-inverse"})]),_vm._v(" "),_c('h2',[_vm._v("\n            Get Live Updates\n          ")])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('fieldset',[_c('label',[_vm._v("Notify you when this machine is available via:")]),_vm._v(" "),(_vm.canSms)?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.isEmail),expression:"form.isEmail"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "isEmail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.alertTypeChange]}},_vm._l((_vm.availableAlerts),function(alertType,idx){return _c('option',{key:idx,domProps:{"value":alertType.isEmail}},[_vm._v(_vm._s(alertType.title))])}),0)]:_vm._e(),_vm._v(" "),(_vm.form.isEmail)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"type":"email","placeholder":"your@email.com"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}):_c('masked-input',{attrs:{"mask":"(111) 111-1111","placeholder":"phone number","type":"text"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}),_vm._v(" "),_c('label',{attrs:{"for":"commentField"}},[_vm._v("Send update...")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.machineTimeBeforeComplete),expression:"form.machineTimeBeforeComplete"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "machineTimeBeforeComplete", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.alertTriggers),function(trigger,idx){return _c('option',{key:idx,domProps:{"value":trigger.remainingSeconds}},[_vm._v(_vm._s(trigger.title))])}),0),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.modalButtonDisabled},on:{"click":_vm.submit}},[_vm._v("Alert Me")])],2)])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header"},[_c('h3',[_vm._v("\n          Live Statuses\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"hide-td"},[_vm._v("Node")]),_vm._v(" "),_c('th',[_vm._v("Machine")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_data__ = __webpack_require__("QevY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Directory",
  data: function data() {
    return {
      orgId: null,
      organizationName: "",
      rooms: []
    };
  },
  mounted: function mounted() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_0__services_data__["b" /* getDirectory */])(this.$route.params.roomId).then(function (results) {
      var data = results.data;

      self.organizationName = data.organization;
      self.orgId = data.id;
      self.rooms = data.rooms;
    });
  },

  methods: {}
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app"
});

/***/ }),

/***/ "xLEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var canvas = void 0;
var layoutObj = void 0;
var grid = 20;
var gridWidth = 20;
var gridHeight = 20;
var gridRows = 40;
var gridColumns = 40;
var almostDoneThreshold = 240; // Seconds until cycle complete
var $container = void 0;
var k = void 0;
var x = void 0;
var y = void 0;
var theme = 'default';
var timerObject = void 0;

var roomSettings = {
  canvasResize: false,
  backgroundColor: "",
  hasBackgroundImage: false,
  canvas: {
    top: null,
    bottom: null,
    left: null,
    right: null,
    padding: 20
  }
};

// Track pending async asset loads to prevent race conditions
var pendingAssetLoads = 0;
var canvasResizeNeeded = false;
var machineUpdateNeeded = false;
var vueComponentInstance = null;
var latestMachineData = null;

function startAssetLoad() {
  pendingAssetLoads++;
}

function completeAssetLoad() {
  pendingAssetLoads--;
  if (pendingAssetLoads === 0) {
    if (canvasResizeNeeded) {
      canvasResizeNeeded = false;
      canvasSizeUpdate();
    }

    // Force machine update if status updates arrived while assets were loading
    if (machineUpdateNeeded && vueComponentInstance && latestMachineData) {
      machineUpdateNeeded = false;
      // Use setTimeout to ensure canvas is fully rendered
      setTimeout(function () {
        vueComponentInstance.machineUpdate(latestMachineData);
      }, 0);
    }
  }
}

function requestCanvasResize() {
  if (pendingAssetLoads === 0) {
    canvasSizeUpdate();
  } else {
    canvasResizeNeeded = true;
  }
}

function resetCanvasBounds() {
  roomSettings.canvas.top = null;
  roomSettings.canvas.bottom = null;
  roomSettings.canvas.left = null;
  roomSettings.canvas.right = null;
}

function getMachineTypeAbbrev(machineType) {
  var id = Number(machineType.id);

  // First we try to find the type based on the machine type id
  // Taken from machine-types model
  var dryerIds = [20, 21, 22, 23, 24];
  var dryerStackIds = [22, 23, 24];
  var tumblerIds = [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];
  var tumblerStackIds = [33, 34, 35, 37, 38, 39, 51, 52, 53];
  var extractorIds = [100, 101, 102, 103, 104, 105, 106, 107, 108, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 151, 152, 242, 243, 244, 245, 246, 247, 248, // MC10 machines
  255, 256, 257, 258, 259, 260, 261, 262, 263 // Mid/Large MC10 OPL machines
  ];
  var toploadIds = [0];
  var frontloadIds = [10];

  if (dryerStackIds.includes(id)) {
    return 'dry-stack';
  }
  if (dryerIds.includes(id)) {
    return 'dry';
  }
  if (tumblerStackIds.includes(id)) {
    return 'tum-stack';
  }
  if (tumblerIds.includes(id)) {
    return 'tum';
  }
  if (extractorIds.includes(id)) {
    return 'wx';
  }
  if (toploadIds.includes(id)) {
    return 'tlw';
  }
  if (frontloadIds.includes(id)) {
    return 'flw';
  }

  // If the ID is not found, we try to find the type based on the machine typeName
  var typeName = (machineType.typeName || "").toLowerCase();

  if (typeName.includes('dryer')) {
    return 'dry';
  }
  if (typeName.includes('tumbler')) {
    return 'tum';
  }
  if (typeName.includes('extractor')) {
    return 'wx';
  }
  if (typeName.includes('frontload')) {
    return 'flw';
  }
  if (typeName.includes('topload')) {
    return 'tlw';
  }

  // And finally we'll fall back to isDryer/isWasher
  if (machineType.isDryer) {
    return 'tum';
  }

  if (machineType.isWasher) {
    return 'wx';
  }

  // And if none of that works...
  console.warn('Could not find machine type abbreviation for a machine');
  return 'unknown';
}

function hasWindow(modelNumber) {
  // Dryer has a window if the 8th character of model is W
  return modelNumber && modelNumber.length > 7 && modelNumber[7] === 'W' ? true : false;
}

function hasRearControls(modelNumber) {
  // FLW and DRY have rear controls if the 6th character of model is R
  return modelNumber && modelNumber.length > 5 && modelNumber[5] === 'R' ? true : false;
}

function createMachine(machine, machineStatus, themeConfig) {
  var self = this;
  var color = void 0;

  var machineId = machine.id;
  var machineName = machine.machineName;
  var machineNumber = machine.machineNumber.replace(/^0+/, "");

  if (machine) {
    color = statusColor(machineStatus, themeConfig);
  } else {
    color = statusColor('', themeConfig);
  }

  var modelNumber = machine.modelNumber || "";
  var machineIcon = getMachineTypeAbbrev({
    id: machine.machineType.id,
    isDryer: machine.isDryer,
    isWasher: machine.isWasher,
    machineType: machine.machineType
  });

  var machineAuditType = machine.machineAuditType;
  var svgIcon = void 0;

  if (hasRearControls(modelNumber)) {
    machineIcon += "-back";
  }
  if (hasWindow(modelNumber)) {
    machineIcon += "-window";
  }

  var theme = themeConfig.name;
  if (machineAuditType && Object.prototype.hasOwnProperty.call(themeConfig, machineAuditType)) {
    // Icons specific to the machine audit type
    svgIcon = "themes/" + theme + "/" + themeConfig[machineAuditType][machineIcon];
  } else {
    svgIcon = "themes/" + theme + "/" + themeConfig.icons[machineIcon];
  }

  startAssetLoad();

  // Add timeout to prevent hanging if SVG fails to load
  var svgLoadTimeout = setTimeout(function () {
    console.warn('SVG load timeout for:', "/static/" + svgIcon + ".svg");
    completeAssetLoad();
  }, 10000); // 10 second timeout

  fabric.loadSVGFromURL("/static/" + svgIcon + ".svg", function (objects, options) {
    clearTimeout(svgLoadTimeout);
    var group = void 0;
    var obj = fabric.util.groupSVGElements(objects, options);
    var left = machine.washAlertXAxis;
    var top = machine.washAlertYAxis;
    var scaleX = machine.washAlertScaleX || 1;
    var scaleY = machine.washAlertScaleY || 1;
    var angle = machine.washAlertAngle || 0;
    var zIndex = machine.washAlertZIndex || 1;

    var rotationAngle = 0;
    var flipX = false;
    var flipY = false;
    var leftTextOffset = 0;
    var topTextOffset = 0;
    var textInSVG = false;

    obj.set({
      left: left,
      top: top,
      width: gridWidth,
      height: gridWidth,
      fill: "rgb(127, 140, 141)",
      originX: "left",
      originY: "top",
      borderColor: "white",
      centeredRotation: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: true,
      hasControls: true,
      cornerSize: 8,
      hasBorders: false,
      padding: 0,
      scaleX: 1,
      scaleY: 1
    });

    // sets the color of the svg object to the right status color
    function updateColors(obj) {
      if (obj.fill == '#ccc' || obj.id == 'fill-#ccc') {
        obj.set({ fill: color[0] });
      } else if (obj.fill == '#aaa' || obj.id == 'fill-#aaa') {
        obj.set({ fill: color[1] });
      }

      if (obj.stroke == '#ccc' || obj.id == 'stroke-#ccc') {
        obj.set({ stroke: color[0] });
      } else if (obj.stroke == '#aaa' || obj.id == 'stroke-#aaa') {
        obj.set({ stroke: color[1] });
      }
    }

    updateColors(obj);

    // also check sub shapes to the right status color
    for (var _x in obj._objects) {
      updateColors(obj._objects[_x]);

      if (obj._objects[_x].text == '123' || obj._objects[_x].text === '--') {
        // '123' was used in the past, but resembles real data if it gets displayed. Now using '--' as the placeholder.
        textInSVG = true;
        obj._objects[_x].text = getIconText();
      }
    }

    function getIconText() {
      var iconText = machineNumber.replace(/^0+/, "");
      iconText = machineNumber.replace(/^#/, "");
      if (machineName.length < 8) {
        iconText = machineName;
      }
      return iconText;
    }

    if (!textInSVG) {

      // Text positioning is stored in the theme.json file
      var textConfig = themeConfig.text;
      var textAlign = textConfig ? textConfig["text-align"] || "center" : "center";
      var fontFamily = textConfig ? textConfig["font-family"] || "Arial, Helvetica" : "Arial, Helvetica";
      var shadow = textConfig ? textConfig["shadow"] || "rgba(0,0,0,1) 0px 0px 1px" : "rgba(0,0,0,1) 0px 0px 1px";
      var fill = textConfig ? textConfig["fill"] || "white" : "white";
      var fontSize = textConfig ? textConfig["font-size"] || 3 : 3;
      var timerFontSize = textConfig ? textConfig["timer-font-size"] || 3 : 3;

      var text = new fabric.Textbox(getIconText(), {
        fontSize: fontSize,
        textAlign: textAlign,
        fill: fill,
        fontFamily: fontFamily,
        shadow: shadow
      });

      var verticalAlign = textConfig ? textConfig["vertical-align"] || "top" : "top";

      // Padding values are used to move the text down/up from the top/bottom borders of the icon
      var paddingTop = textConfig && textConfig["padding-top"] ? textConfig["padding-top"] : 0;
      var paddingBottom = textConfig && textConfig["padding-bottom"] ? textConfig["padding-bottom"] : 0;

      // Padding values are used to reduce the text width to center it on 3-D icons
      var paddingRight = textConfig && textConfig["padding-right"] ? textConfig["padding-right"] : 0;
      var paddingLeft = textConfig && textConfig["padding-left"] ? textConfig["padding-left"] : 0; // Not usually used

      var textTop = void 0,
          textLeft = void 0;
      if (verticalAlign === "top") {
        textTop = top + paddingTop;
      } else {
        textTop = top + gridWidth - paddingBottom;
      }

      // If the left is adjusted, we also need to reduce the width or the group (text + icon) will be offset incorrectly
      var textWidth = gridWidth - paddingRight - paddingLeft;

      text.set({
        top: textTop,
        left: left,
        width: textWidth,
        scaleX: 1,
        scaleY: 1
      });

      var timerTopOffset = Number(themeConfig['timer-top-offset'] || 9);
      var timerTopPosition = Number(top) + timerTopOffset;

      var timerTextConfig = {
        fontSize: timerFontSize,
        textAlign: textAlign,
        fill: fill,
        fontFamily: fontFamily,
        shadow: "black 0px 0px 1px",
        top: timerTopPosition,
        left: left,
        width: textWidth + (themeConfig['timer-width-offset'] || 0),
        scaleX: 1,
        scaleY: 1,
        visibility: false,
        data: {
          machineId: machine.id,
          remainingSeconds: machine.remainingSeconds,
          type: 'timer'
        }
      };
      var timerText1 = new fabric.Textbox('', timerTextConfig);
      var timerText2 = new fabric.Textbox('', timerTextConfig);
      var timerText3 = new fabric.Textbox('', timerTextConfig);
      var timerText4 = new fabric.Textbox('', timerTextConfig);

      group = new fabric.Group([obj, text, timerText1, timerText2, timerText3, timerText4]);
    } else {
      group = new fabric.Group([obj]);
    }

    // set the properties of the new group
    group.set({
      scaleX: 1,
      scaleY: 1,
      width: gridWidth,
      height: gridWidth,
      angle: angle,
      lockRotation: true,
      lockScalingFlip: true,
      isMachineGroup: true,
      isNew: true,
      machineStatus: machineStatus,
      machineName: machineName,
      machineNumber: machineNumber,
      machineId: machineId,
      canvasType: 'machine',
      selectable: false,
      hoverCursor: 'default',
      zIndex: zIndex
    });

    var scaleWidth = Math.round(scaleX) * gridWidth - 1;
    var scaleHeight = Math.round(scaleX) * gridWidth - 1;
    group.scaleToWidth(scaleWidth, true);
    group.scaleToHeight(scaleHeight, true);

    // finally adds the new group to the board
    canvas.add(group);
    checkCanvasSize(group);
    sortCanvas();
    completeAssetLoad();
  });
}

function sortCanvas() {
  var objectsToSort = [];
  canvas.forEachObject(function (obj) {
    if (obj.zIndex) {
      objectsToSort.push(obj);
    }
  });

  objectsToSort.sort(function (a, b) {
    if (a.zIndex < b.zIndex) {
      return -1;
    } else if (a.zIndex > b.zIndex) {
      return 1;
    }
    return 0;
  });

  objectsToSort.forEach(function (obj) {
    obj.moveTo(obj.zIndex);
  });

  canvas.renderAll();
}

function isActive(statusId) {
  return statusId && ["in_use", "almost_done", "lucky_cycle"].includes(statusId && statusId.toLowerCase());
}

function statusColor(status, themeConfig) {

  // Return status colors defined in theme.json -or- defaultColors -or- fallbackColors
  if (status !== undefined) {
    status = status.toUpperCase();
  } else {
    status = "INIT";
  }

  // TODO: Check the remainingSeconds to change the status to ALMOST_DONE.
  // We don't do that now because the control sends an updated remainingSeconds every minute, and that value may not be 60 seconds less than the previous value.

  var fallbackColors = ["#c6cccf", "#999d9e"];
  var defaultStatusList = [{
    label: "available",
    status: ["AVAILABLE"],
    colors: ["#45b854", "#128521"],
    in_legend: true
  }, {
    label: "in use",
    status: ["IN_USE", "ALMOST_DONE", "LUCKY_CYCLE", "READY_TO_START", "DOOR_OPEN"],
    colors: ["#f3a537", "#c07204"],
    in_legend: true
  }, {
    label: "complete",
    status: ["COMPLETE"],
    colors: ["#2a8bda", "#0058a7"],
    in_legend: true
  }, {
    label: "error",
    status: ["ERROR"],
    colors: ["#D0011B", "#a90015"],
    in_legend: true
  }, {
    label: "offline",
    status: ["DEFAULT", "UNKNOWN", "NETWORK_ERROR", "UNAVAILABLE", "INIT"],
    colors: ["#c6cccf", "#93999c"],
    in_legend: true
  }];

  var statusList = void 0;

  if (themeConfig.status) {
    statusList = themeConfig.status;
  } else {
    statusList = defaultStatusList;
  }

  function findStatus(status, statusList) {
    return statusList.find(function (item) {
      return item.status.includes(status);
    });
  }

  // Return the correct colors to use
  if (findStatus(status, statusList)) {
    return findStatus(status, statusList).colors;
  }
  if (findStatus("DEFAULT", statusList)) {
    return findStatus("DEFAULT", statusList).colors;
  }
  return fallbackColors;
}

function createLayout(url, left, top, scaleX, scaleY, angle) {
  var self = this;
  startAssetLoad();

  fabric.Image.fromURL(url, function (img) {
    var oImg = img.set({
      id: 'layout',
      left: left,
      top: top,
      scaleX: scaleX,
      scaleY: scaleY,
      angle: angle,
      selectable: false,
      ignoreOnHover: true,
      hoverCursor: 'default',
      zIndex: 0
    });
    canvas.add(oImg);
    oImg.sendToBack();
    checkCanvasSize(oImg);
    completeAssetLoad();
  }, null, function (error) {
    console.warn('Failed to load layout image:', url, error);
    completeAssetLoad();
  });
}

function createLabel(label) {
  var text = new fabric.Textbox(label.labelText, {
    top: label.labelY,
    left: label.labelX,
    scaleX: label.labelScaleX,
    scaleY: label.labelScaleY,
    fontFamily: label.labelFont || "Helvetica",
    fontSize: label.labelFontSize || 10,
    fontWeight: label.labelWeight || "",
    fontStyle: label.labelStyle || "",
    underline: label.labelUnderline || "",
    angle: label.labelAngle,
    textAlign: "left",
    fill: label.labelColor,
    backgroundColor: label.labelBgColor,
    width: label.width,
    canvasType: 'label',
    selectable: false,
    hoverCursor: 'default',
    zIndex: label.zIndex || 1000
  });
  canvas.add(text);
  sortCanvas();
  checkCanvasSize(text);
}

function checkCanvasSize(obj) {

  // let top = obj.top;
  // let bottom = obj.top + (obj.height * obj.scaleY);
  // let left = obj.left;
  // let right = obj.left + (obj.width * obj.scaleX);

  var bounds = obj.getBoundingRect(); // height, left, top, width;
  var top = bounds.top;
  var bottom = bounds.top + bounds.height;
  var left = bounds.left;
  var right = bounds.left + bounds.width;

  if (roomSettings.canvas.top === null || top < roomSettings.canvas.top) {
    roomSettings.canvas.top = top;
  }
  if (roomSettings.canvas.left === null || left < roomSettings.canvas.left) {
    roomSettings.canvas.left = left;
  }
  if (roomSettings.canvas.right === null || right > roomSettings.canvas.right) {
    roomSettings.canvas.right = right;
  }
  if (roomSettings.canvas.bottom === null || bottom > roomSettings.canvas.bottom) {
    roomSettings.canvas.bottom = bottom;
  }
}

function createImage(s3ImageUrl, filename, left, top, scaleX, scaleY, angle, zIndex) {
  var selectable = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
  var ignoreOnHover = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;

  var path = s3ImageUrl + "/rooms/" + filename;
  startAssetLoad();

  fabric.Image.fromURL(path, function (imageObject) {
    var options = {
      id: 'image',
      left: left,
      top: top,
      scaleX: scaleX ? scaleX : 1,
      scaleY: scaleY ? scaleY : 1,
      angle: angle,
      ignoreOnHover: true,
      selectable: false,
      zIndex: zIndex,
      filename: filename
    };
    imageObject.set(options);
    canvas.add(imageObject);
    canvas.moveTo(imageObject, zIndex);
    sortCanvas();
    checkCanvasSize(imageObject);
    completeAssetLoad();
  }, null, function (error) {
    console.warn('Failed to load image:', path, error);
    completeAssetLoad();
  });
}

// Resize the canvas to remove extra white space
function canvasSizeUpdate() {
  if (roomSettings.canvasResize) {
    // We remove padding from the top and bottom if there is a background image
    if (roomSettings.hasBackgroundImage) {
      roomSettings.canvas.padding = 0;
    }

    var topOffset = -1 * (roomSettings.canvas.top - roomSettings.canvas.padding);
    if (topOffset > 0) topOffset = 0; // Top cannot be out of bounds

    var bottom = roomSettings.canvas.bottom;
    if (bottom > 800) bottom = 800; // Bottom cannot be out of bounds

    var adjustedHeight = parseInt(bottom + topOffset + roomSettings.canvas.padding);
    if (adjustedHeight > 800) adjustedHeight = 800;

    document.getElementById('c').style.marginTop = topOffset + 'px'; // Adjust the top
    document.getElementById('canvas-container').style.height = adjustedHeight + 'px'; // Adjust the height
    document.getElementById('canvas-container').style.backgroundColor = roomSettings.backgroundColor || "#fff"; // Match the canvas background color
  }

  // Show the canvas container
  document.getElementById('canvas-container').style.display = 'block';
  document.getElementById('room-view').style.display = 'block';
  document.getElementById('loader').style.display = 'none';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Room",
  props: {
    id: Number,
    roomId: Number,
    gridSizePx: Number,
    roomLabelMeta: Array,
    roomName: String,
    roomLogo: String
  },
  data: function data() {
    return {
      showClock: false,
      showLegend: false,
      showLeftColumn: false,
      s3ImagePath: ''
    };
  },
  mounted: function mounted() {
    // Store reference to this component for use in asset loading callbacks
    vueComponentInstance = this;

    $container = this.$refs.container;
    canvas = new fabric.Canvas("c", {
      selection: false,
      enableRetinaScaling: false
    });

    // Fix for fabric.js 5.3.1 textBaseline issue
    // Override CanvasRenderingContext2D textBaseline setter to prevent invalid values
    var originalTextBaselineDescriptor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(CanvasRenderingContext2D.prototype, 'textBaseline');
    if (originalTextBaselineDescriptor && originalTextBaselineDescriptor.set) {
      Object.defineProperty(CanvasRenderingContext2D.prototype, 'textBaseline', {
        get: originalTextBaselineDescriptor.get,
        set: function set(value) {
          // Convert invalid 'alphabetical' to valid 'alphabetic'
          if (value === 'alphabetical') {
            value = 'alphabetic';
          }
          originalTextBaselineDescriptor.set.call(this, value);
        }
      });
    }

    this.timerUpdate();
  },
  beforeDestroy: function beforeDestroy() {
    // Clean up references when component is destroyed
    if (vueComponentInstance === this) {
      vueComponentInstance = null;
      latestMachineData = null;
      machineUpdateNeeded = false;
    }
  },

  methods: {
    roomUpdate: function roomUpdate(room, machines, config) {
      var _this = this;

      var self = this;

      // Reset canvas bounds for new room load
      resetCanvasBounds();

      // Reset machine update flags for new room load
      machineUpdateNeeded = false;
      latestMachineData = null;

      this.showClock = config.showClock;
      this.showLegend = config.showLegend;
      this.showLeftColumn = this.showClock || this.showLegend;
      roomSettings.canvasResize = config.canvasResize;
      this.s3ImagePath = config.s3ImagePath;
      this.themeConfig = config.themeConfig;

      // Only init the clock if we need to show it
      if (this.showClock && !this.clockInitialized) {
        setTimeout(function () {
          $("#clock").thooClock({
            size: 180,
            secondHandColor: "#cc0000"
          });
          _this.clockInitialized = true;
        }, 1000);
      }

      var themeConfig = config.themeConfig;

      if (room.backgroundColor) {
        canvas.set('backgroundColor', room.backgroundColor);
        roomSettings.backgroundColor = room.backgroundColor;
      }

      if (themeConfig.background) {
        roomSettings.background = themeConfig.background;
      }

      if (room.roomCustomImageUrl) {
        // Draw background image
        createLayout(room.roomCustomImageUrl, room.washAlertXAxis, room.washAlertYAxis, room.washAlertScaleX, room.washAlertScaleY, room.washAlertAngle);
        roomSettings.hasBackgroundImage = true;
      }

      // if (room.washAlertGridlinesOnBg) {
      //   // Draw Canvas Grid
      //   createGrid(this.gridSizePx);
      // }

      // Draw machines
      for (var i in machines) {
        if (machines[i].washAlertIsVisible && machines[i].machineNumber) {
          createMachine(machines[i], machines[i].statusId, this.themeConfig);
        }
      }
      var s3ImageUrl = room.s3ImagePath;

      // Draw Canvas labels
      if (room.roomLabelMeta) {
        room.roomLabelMeta.forEach(function (item) {
          if (item.filename) {
            var filename = item.filename,
                positionX = item.positionX,
                positionY = item.positionY,
                scaleX = item.scaleX,
                scaleY = item.scaleY,
                angle = item.angle,
                zIndex = item.zIndex;

            createImage(s3ImageUrl, filename, positionX, positionY, scaleX, scaleY, angle, zIndex);
          } else if (item.type === undefined || item.type === "label" || item.type === "text") {
            var txt = item;
            createLabel(item);
          }
        });
      }

      if (window.location.href.indexOf("mode=tv") != -1) {
        $(window).resize(function () {
          canvas.setDimensions({ width: window.innerHeight - 80, height: window.innerHeight - 80 });
          canvas.setZoom((window.innerHeight - 80) / self.gridSizePx);
        });

        canvas.setDimensions({ width: window.innerHeight - 80, height: window.innerHeight - 80 });
        canvas.setZoom((window.innerHeight - 80) / this.gridSizePx);
      }

      sortCanvas();
      canvas.renderAll();

      // Request canvas resize after all assets are loaded
      requestCanvasResize();
    },
    timerUpdate: function timerUpdate() {
      // Any status updates will trigger a change to the timer in the `machineUpdate` function.
      // All this function cares about are `isActive` machines that need their timer updated.
      if (timerObject !== undefined) {
        clearInterval(timerObject);
      }

      timerObject = setInterval(function () {
        canvas.forEachObject(function (obj) {
          if (obj && obj.canvasType && obj.canvasType == 'machine' && isActive(obj.machineStatus)) {
            obj.remainingSeconds = parseInt(obj.remainingSeconds) - 1;

            // Change status to ALMOST_DONE if remaining seconds is less than 4 minutes
            if (obj.remainingSeconds < almostDoneThreshold) {
              obj.statusId = "ALMOST_DONE";
            }

            var duration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(obj.remainingSeconds, "seconds");
            var seconds = duration.seconds();
            var minutes = parseInt(duration.minutes()) + parseInt(duration.hours()) * 60;
            var timerText = __WEBPACK_IMPORTED_MODULE_1_lodash__["filter"](obj._objects, { type: 'textbox', data: { type: 'timer' } });
            var newText = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");

            if (duration < 0) {
              timerText.forEach(function (text) {
                text.set('text', "--:--");
              });
            } else if (newText) {
              timerText.forEach(function (text) {
                text.set('text', newText);
              });
            } else {
              console.log('*** no text');
            }
          }
        });
        canvas.renderAll();
      }, 1000);
    },


    // This function is called from `Home.vue` every time we get an update from Firebase.
    machineUpdate: function machineUpdate(machines) {
      var _this2 = this;

      // Store latest machine data for use after asset loading completes
      latestMachineData = machines;

      // If assets are still loading, defer the update until they complete
      if (pendingAssetLoads > 0) {
        machineUpdateNeeded = true;
        return;
      }

      // Request canvas resize (will happen after all pending assets load)
      requestCanvasResize();

      // Loop through every machine and update things

      var _loop = function _loop() {
        var machine = machines[i];

        canvas.forEachObject(function (obj) {
          // Find this machine on the canvas.
          if (obj && obj.canvasType && obj.canvasType == 'machine' && obj.machineId == machine.id) {

            // Skip any machines without an update flag
            if (!machine.hasUpdate) {
              return;
            }

            // Reset the update flag
            machine.hasUpdate = false;

            // Update the visibility of the timer text and the remaining seconds
            var timerText = __WEBPACK_IMPORTED_MODULE_1_lodash__["filter"](obj._objects, { type: 'textbox', data: { type: 'timer' } });
            timerText.forEach(function (text) {
              text.set('visible', isActive(machine.statusId));
            });

            obj.remainingSeconds = machine.remainingSeconds;

            // Always update the status color to ensure consistency
            var oldColor = statusColor(obj.get('machineStatus'), _this2.themeConfig);
            var newColor = statusColor(machine.statusId, _this2.themeConfig);

            obj.set('machineStatus', machine.statusId);

            // sets the color of the svg object to the right status color
            if (obj._objects[0].fill == oldColor[0] || obj._objects[0].id == 'fill-#ccc') {
              obj._objects[0].set({ fill: newColor[0] });
            } else if (obj._objects[0].fill == oldColor[1] || obj._objects[0].id == 'fill-#aaa') {
              obj._objects[0].set({ fill: newColor[1] });
            }

            if (obj._objects[0].stroke == oldColor[0] || obj._objects[0].id == 'stroke-#ccc') {
              obj._objects[0].set({ stroke: newColor[0] });
            } else if (obj._objects[0].stroke == oldColor[1] || obj._objects[0].id == 'stroke-#aaa') {
              obj._objects[0].set({ stroke: newColor[1] });
            }

            // also check sub shapes to the right status color
            for (x in obj._objects[0]._objects) {
              if (obj._objects[0]._objects[x].fill == oldColor[0] || obj._objects[0]._objects[x].id == 'fill-#ccc') {
                obj._objects[0]._objects[x].set({ fill: newColor[0] });
              } else if (obj._objects[0]._objects[x].fill == oldColor[1] || obj._objects[0]._objects[x].id == 'fill-#aaa') {
                obj._objects[0]._objects[x].set({ fill: newColor[1] });
              }

              if (obj._objects[0]._objects[x].stroke == oldColor[0] || obj._objects[0]._objects[x].id == 'stroke-#ccc') {
                obj._objects[0]._objects[x].set({ stroke: newColor[0] });
              } else if (obj._objects[0]._objects[x].stroke == oldColor[1] || obj._objects[0]._objects[x].id == 'stroke-#aaa') {
                obj._objects[0]._objects[x].set({ stroke: newColor[1] });
              }
            }
          }
        });
      };

      for (var i in machines) {
        _loop();
      }
      canvas.renderAll();
    }
  }
});

/***/ }),

/***/ "xcT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"margin":"0 auto","width":"68px"},attrs:{"id":"loader"}},[_c('svg',{attrs:{"width":"68px","height":"80px","viewBox":"0 0 68 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"Ideas","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Scrubbrush-Top-Pills-Copy","transform":"translate(-1222.000000, -788.000000)","fill":"#CCCCCC"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(1222.000000, 788.000000)"}},[_c('path',{attrs:{"d":"M0.00419495803,18 L2.40419496,76 C2.50419496,78.2 4.40419496,80 6.60419496,80 L60.504195,80 C62.704195,80 64.604195,78.2 64.704195,76 L67.304195,18 L0.00419495803,18 Z M33.604195,70.7 C20.904195,70.7 10.604195,60.4 10.604195,47.7 C10.604195,35 20.904195,24.7 33.604195,24.7 C46.304195,24.7 56.604195,35 56.604195,47.7 C56.604195,60.4 46.304195,70.7 33.604195,70.7 Z M63.404195,12 L63.204195,12 L61.504195,0 L5.70419496,0 L4.00419496,12 L3.80419496,12 C1.60419496,12 -0.095805042,14 0.00419495803,16.2 L0.00419495803,17 L67.304195,17 L67.304195,16.2 C67.404195,14 65.604195,12 63.404195,12 Z M54.904195,4.8 C56.104195,4.8 57.104195,5.8 57.104195,7 C57.104195,8.2 56.104195,9.2 54.904195,9.2 C53.704195,9.2 52.704195,8.2 52.704195,7 C52.704195,5.8 53.704195,4.8 54.904195,4.8 Z M47.904195,4.8 C49.104195,4.8 50.104195,5.8 50.104195,7 C50.104195,8.2 49.104195,9.2 47.904195,9.2 C46.704195,9.2 45.704195,8.2 45.704195,7 C45.704195,5.8 46.704195,4.8 47.904195,4.8 Z M41.104195,4.8 C42.304195,4.8 43.304195,5.8 43.304195,7 C43.304195,8.2 42.304195,9.2 41.104195,9.2 C39.904195,9.2 38.904195,8.2 38.904195,7 C38.904195,5.8 39.904195,4.8 41.104195,4.8 Z M18.704195,8.9 C18.704195,9.5 18.204195,10 17.604195,10 L11.804195,10 C11.204195,10 10.704195,9.5 10.704195,8.9 L10.704195,6.1 C10.704195,5.5 11.204195,5 11.804195,5 L17.604195,5 C18.204195,5 18.704195,5.5 18.704195,6.1 L18.704195,8.9 Z","id":"Shape","fill-rule":"nonzero"}}),_vm._v(" "),_c('path',{staticClass:"rotating",attrs:{"d":"M51.804195,53.2 C49.404195,61 42.204195,66.6 33.604195,66.6 C23.104195,66.6 14.604195,58.1 14.604195,47.6 C14.604195,44.9 15.204195,42.4 16.204195,40 C26.604195,35.6 35.004195,59.8 51.804195,53.2 L51.804195,53.2 Z","id":"Path-Copy"}})])])])])]),_vm._v(" "),_c('div',{attrs:{"id":"room-view"}},[_c('div',{staticClass:"row center"},[(_vm.showLeftColumn)?_c('div',{staticClass:"column"},[_c('div',{attrs:{"id":"info"}},[(_vm.roomLogo)?_c('img',{staticClass:"hero-logo",attrs:{"src":_vm.roomLogo}}):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.roomName))])]),_vm._v(" "),(_vm.showClock)?_c('div',{attrs:{"id":"clock"}}):_vm._e(),_vm._v(" "),(_vm.showLegend)?_c('div',{attrs:{"id":"legend"}},[_c('h4',{staticClass:"available"},[_vm._v("Available")]),_vm._v(" "),_c('h4',{staticClass:"in_use"},[_vm._v("In Use")]),_vm._v(" "),_c('h4',{staticClass:"complete"},[_vm._v("Complete")]),_vm._v(" "),_c('h4',{staticClass:"error"},[_vm._v("Error")]),_vm._v(" "),_c('h4',{staticClass:"offline"},[_vm._v("Offline")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{attrs:{"id":"canvas-container"}},[_c('div',{ref:"container",attrs:{"id":"wa-container"}}),_vm._v(" "),_c('canvas',{staticStyle:{"_visibility":"hidden"},attrs:{"id":"c","width":_vm.gridSizePx,"height":_vm.gridSizePx}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yoog":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-pill",class:_vm.statusClassObject,style:({background: _vm.statusColor})},[_vm._v("\n  "+_vm._s(_vm.statusFormatted)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yqGW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zd0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6663f9ea6aea8bdf5f5f.js